import { DuplicateIcon } from '@cycle-app/ui/icons';

import { RELEASE_NOTE_EDITOR_CONTAINER } from 'src/constants/releases.constants';
import { addToaster } from 'src/utils/toasters.utils';

import { Action } from './ReleaseNote.styles';

export const ReleaseNoteCopyContent = () => {
  return (
    <Action
      tooltip="Copy release note to clipboard"
      tooltipPlacement="bottom"
      onClick={() => {
        copyContent();
        addToaster({ title: 'Release note copied to clipboard' });
      }}
    >
      <DuplicateIcon size={16} />
    </Action>
  );
};

const copyContent = () => {
  const selection = window.getSelection();
  if (!selection) return;

  const element = document.querySelector(`.${RELEASE_NOTE_EDITOR_CONTAINER}`);
  if (!element) return;

  const range = document.createRange();
  range.selectNode(element);

  selection.removeAllRanges();
  selection.addRange(range);
  document.execCommand('copy');
  selection.removeAllRanges();
};
